export default "__VITE_ASSET__DjcpIRQO__"